import {Component} from '@angular/core';

export interface Food {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'select-overview.component',
  templateUrl: 'select-overview.component.html',
  styleUrls: ['select-overview.component.scss'],
})

export class SelectOverviewComponent {
  foods: Food[] = [
    {value: 'steak-0', viewValue: 'Steak'},
    {value: 'pizza-1', viewValue: 'Pizza'},
    {value: 'tacos-2', viewValue: 'Tacos'}
  ];
}


// WEBPACK FOOTER //
// ./src/app/shared-components/select-overview/select-overview.component.ts